import { observable } from "mobx";
import { Type } from "class-transformer";
import BankOperationType from "./bankOperationType";
import CounterpartyBankAccountType from "./counterpartyBankAccountType";
import DomesticBankAccountResponse from "./domesticBankAccountResponse";
import PaymentFeeType from "./paymentFeeType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class TransferPaymentDetailResponse {
  /**
   * Payment ID.
   */
  id!: string;

  @observable
  @Type(() => DomesticBankAccountResponse)
  bankAccount!: DomesticBankAccountResponse;

  /**
   * Payment template ID.
   */
  @observable
  paymentTemplateId?: string;

  /**
   * Bank transaction id.
   */
  @observable
  bankTransactionId!: string;

  /**
   * External bank transaction id.
   */
  @observable
  externalBankTransactionId?: string;

  /**
   * Bank transaction type.
   */
  @observable
  bankTransactionType!: string;

  @observable
  counterpartyAccountType!: CounterpartyBankAccountType;

  /**
   * Counterparty account number.
   */
  @observable
  counterpartyAccountNumber?: string;

  /**
   * Counterparty bank.
   */
  @observable
  counterpartyBank?: string;

  /**
   * Counterparty name.
   */
  @observable
  counterpartyName?: string;

  /**
   * Counterparty address.
   */
  @observable
  counterpartyAddress?: string;

  @observable
  operationType!: BankOperationType;

  /**
   * Amount.
   */
  @observable
  amount!: number;

  /**
   * Variable symbol.
   */
  @observable
  variableSymbol?: number;

  /**
   * Specific symbol.
   */
  @observable
  specificSymbol?: number;

  /**
   * Constant symbol.
   */
  @observable
  constantSymbol?: number;

  /**
   * New variable symbol.
   */
  @observable
  newVariableSymbol?: number;

  /**
   * Posting date.
   */
  @observable
  @Type(() => Date)
  postingDate!: Date;

  /**
   * Currency date.
   */
  @observable
  @Type(() => Date)
  currencyDate?: Date;

  /**
   * Debiting date.
   */
  @observable
  @Type(() => Date)
  debitingDate?: Date;

  @observable
  paymentFeeType?: PaymentFeeType;

  /**
   * Message for recipient.
   */
  @observable
  messageForRecipient?: string;

  /**
   * Additional information.
   */
  @observable
  additionalInformation?: string;

  /**
   * Statement date.
   */
  @observable
  @Type(() => Date)
  statementDate!: Date;

  /**
   * Created at.
   */
  @observable
  @Type(() => Date)
  createdAt!: Date;
}
